<template>
  <b-form-group
    label="Başlangıç Tarihi"
    label-for="title"
  >
    <b-form-datepicker
      id="sdate"
      v-model="dataItem.sdate"
      placeholder="Başlangıç Tarihi"
      v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'StartDate',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
}
</script>
